export enum FilterType {
	BLANK = 0,
	INPUT = 1,
	SINGLE_SELECT = 2,
	MULTI_SELECT = 3,
	RADIO_BUTTON = 4,
	DATE_SELECT = 5,
	BOOLEAN = 6,
	NUMBER = 7
}